import { Router } from '@angular/router';

/** `all` takes every uninvoiced entry of that kind, a list of ids takes only those entries. */
export type InvoiceEntrySelection = string[] | 'all';

export interface IInvoiceCreateSelection {
  time?: InvoiceEntrySelection;
  /** Ids apply to both expenses and mileage, mirroring how the time and expenses list selects them. */
  expenses?: InvoiceEntrySelection;
  mileage?: 'all';
}

export const ALL_INVOICE_ENTRIES: IInvoiceCreateSelection = { time: 'all', expenses: 'all', mileage: 'all' };

const toParam = (selection?: InvoiceEntrySelection): string | undefined => {
  if (selection === 'all') return 'all';
  return selection?.length ? selection.join(',') : undefined;
};

/** Reads a selection query param back. Returns null when the param is absent. */
export const parseInvoiceSelectionParam = (value: string | null): InvoiceEntrySelection | null => {
  if (!value) return null;
  return value === 'all' ? 'all' : value.split(',').filter(Boolean);
};

/** Opens the invoice page to create an invoice from the given entries of an investigation. */
export const openInvoiceCreate = (router: Router, investigationId: string, selection: IInvoiceCreateSelection) =>
  router.navigate(['/admin', 'invoices', 'create', investigationId], {
    queryParams: {
      time: toParam(selection.time),
      expenses: toParam(selection.expenses),
      mileage: selection.mileage,
      returnUrl: router.url
    }
  });

/** Opens the invoice page for an existing invoice, read only when `viewOnly` is set. */
export const openInvoice = (router: Router, invoiceId: string, viewOnly = false) =>
  router.navigate(['/admin', 'invoices', invoiceId], {
    queryParams: {
      mode: viewOnly ? 'view' : undefined,
      returnUrl: router.url
    }
  });
